<template>
    <div v-show="counter_enabled === undefined || counter_enabled === true" class="b-table-checked-counter__container">
        <span v-text="trans('total')"></span>: {{ total_items }},
        <span v-text="trans('chosen')"></span>: {{ checked_count }}
    </div>
</template>

<script>
    import * as Functions from '../Functions';

    export default {
        props: ['counter_enabled', 'translations'],
        data: function() {
            return {
                checked_count : 0,
                total_items: 0
            }
        },
        methods: {
            trans(name, path = null) {
                return Functions.trans(this.translations, name, path);
            }
        },
        //EVENTS
        created: function () {
            this.$root.$on('update:table', (val) => { this.total_items = val.total});
            this.$root.$on('update:checked', (val) => { this.checked_count = val.length});
        }
    };
</script>
